(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("sdp"));
	else if(typeof define === 'function' && define.amd)
		define(["sdp"], factory);
	else if(typeof exports === 'object')
		exports["lib-pixelstreamingfrontend"] = factory(require("sdp"));
	else
		root["lib-pixelstreamingfrontend"] = factory(root["sdp"]);
})(this, (__WEBPACK_EXTERNAL_MODULE_sdp__) => {
return 